import React from 'react';
import { Box, Typography } from '@mui/material';

import { StyledButtonLink } from 'components/common/ViewMoreLink/styles';
import { StyledInputAdornment, StyledTextInput,SearchButton,StyledSearchIcon,StyledXIcon } from './styles';
import { ReactComponent as SearchIcon } from 'images/shared/search.svg';
import EHRDocument from 'images/EHRGuidanceDocument.pdf';

const SearchField = ({ value, onChange, onClear, personId, participantTaskId, onSearch }) => {

  const handleOpenFile = () => {
    window.open(EHRDocument, '_blank');
  };
  
  const handleInputChange = (event) => {
    onChange(event);
  };

  const handleClear = () => {
    onClear();
  };

  const handleSearchClick = async () => {
    if (value.length >= 4 && personId && participantTaskId) {
      onSearch(value);
    }
  };

  return (
    <>
      <Box
        display='flex'
        alignItems='center'
        sx={{ marginBottom: '-20px' }}>
        <Typography
          variant='body2'
          color='primary.gray50'>
          If you are having issues finding your care network, please click
        </Typography>
        <StyledButtonLink
          sx={{ width: '10px', fontSize: '0.875rem' }}
          onClick={handleOpenFile}>
          this link
        </StyledButtonLink>
      </Box>
      <Typography
        variant='body2'
        color='primary.gray50'>
        Search for your care center by name, parent organization name or aliases, full or partial address.
      </Typography>
      <Box
        display='flex'
        gap='10px'
        width='100%'>
        <StyledTextInput
          value={value}
          onChange={handleInputChange}
          placeholder='Search (min. 4 characters)...'
          InputProps={{
            startAdornment : (
              <StyledInputAdornment
                position='start'>
                <SearchIcon
                  width='16px'
                />
              </StyledInputAdornment>
            ),
            endAdornment : (
              value?.length >= 4 && (
                <StyledInputAdornment
                  position='end'
                  onClick={handleClear}
                  style={{ cursor: 'pointer' }}>
                  <StyledXIcon />
                </StyledInputAdornment>
              )
            )
          }}
          sx={{ flex: 1 }}
        />
        <SearchButton
          aria-label='search'
          disabled={value?.length < 4}
          onClick={handleSearchClick}>
          <StyledSearchIcon />
        </SearchButton>
      </Box>
    </>
  );
};

export default SearchField;
